import React from 'react';
import { toast } from 'react-toastify';
import '../components/Auth/LoginWelcomeToast/LoginWelcomeToast.css';

const WELCOME_TOAST_ID = 'login-welcome';

export function getLoginDisplayName(user) {
  if (!user) return '';

  const first = String(user.first_name || '').trim();
  const last = String(user.last_name || '').trim();

  if (first && last) return `${first} ${last}`;
  if (first) return first;
  if (user.name) return String(user.name).trim();
  return String(user.username || '').trim();
}

export function showLoginWelcomeToast(user) {
  if (toast.isActive(WELCOME_TOAST_ID)) return;

  const displayName = getLoginDisplayName(user);
  const roleLabel = String(user?.role_name || '').trim();

  toast.success(
    <div className="login-welcome-toast">
      <div className="login-welcome-toast__icon" aria-hidden="true">
        <span>👋</span>
      </div>
      <div className="login-welcome-toast__content">
        <p className="login-welcome-toast__title">
          Welcome back{displayName ? `, ${displayName}` : ''}!
        </p>
        <p className="login-welcome-toast__subtitle">
          {roleLabel ? `Signed in as ${roleLabel}. ` : ''}
          You have successfully logged in to E-Vitals.
        </p>
      </div>
    </div>,
    {
      toastId: WELCOME_TOAST_ID,
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      className: 'login-welcome-toast-container',
      icon: false,
    }
  );
}
